<template>
  <div id="viewport">
    <!-- Note by Will
    Matt, I'm gonna try somethign a little different here.
    I'm gonna just load every page, and then let each page
    decide whether it should be visible or not based on the
    current URL. That way we have everything initialized up
    front, so there should be fewer surprises / glitches during
    page navigation. -->
    <home-page></home-page>
    <playlist-page playlist="fountain"></playlist-page>
    <playlist-page playlist="plaza"></playlist-page>
    <inductee-page></inductee-page>
    <inductee-details-page></inductee-details-page>
    <device-page></device-page>
    <form id="post-form" enctype="application/x-www-form-urlencoded">
      <input type="hidden" name="_METHOD" value="PUT">
    </form>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  // The x's are so the names don't conflict with built-in or reserved HTML elements,
  components: {
    'home-page'  : require('./HomePage.vue'),
    'playlist-page'  : require('./PlaylistPage.vue'),
    'inductee-page'  : require('./InducteePage.vue'),
    'inductee-details-page'  : require('./InducteeDetailsPage.vue'),
    'device-page'  : require('./DevicePage.vue'),
  }
}
</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  border: 0;
  width: 100%;
  height: 100%;
  background: url(img/bg.jpg) no-repeat top left;
  background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}
body {
  font-family: "myriad-pro", arial, sans-serif;
}
a {
  text-decoration: none;
}
</style>